import { Component, Input } from '@angular/core';

/**
 * BSP-01..03 (13.8, Mario 24-oct): «para el que liquida, más importante es el monto en Bs que en dólares».
 * Cifra principal = Bs; el USD va debajo, pequeño, con la tasa. Quien la usa pasa el Bs YA calculado (la misma
 * tasa de siempre: la del lote o la BCV del día): aquí no se recalcula nada, solo se ordena lo que se ve.
 * Sin Bs (todavía no hay tasa) la principal sigue siendo USD y no hay secundaria (no se inventa un Bs).
 *   parte = 'ambas' (por defecto: principal + secundaria en un span) | 'principal' | 'secundaria'
 * (las tarjetas con dos <p> usan 'principal' y 'secundaria' por separado para conservar su clase).
 */
@Component({
  selector: 'app-monto-bs',
  template: `<ng-container *ngIf="parte !== 'secundaria'"><ng-container *ngIf="tieneBs">Bs {{ bs | number:'1.2-2':'es' }}</ng-container><ng-container *ngIf="!tieneBs">$ {{ usd | number:'1.2-2':'es' }}</ng-container></ng-container><span *ngIf="tieneBs && parte !== 'principal'" [class]="subClass">$ {{ usd | number:'1.2-2':'es' }}<ng-container *ngIf="tasa"> · tasa {{ tasa | number:'1.2-2':'es' }}</ng-container></span>`,
})
export class MontoBsComponent {
  /** Monto en USD (siempre existe). */
  @Input() usd: number | null | undefined = 0;
  /** Monto en Bs ya calculado; null/undefined si no hay tasa. */
  @Input() bs: number | null | undefined = null;
  /** Tasa con la que se calculó el Bs (si no viene, la secundaria no la nombra). */
  @Input() tasa: number | null | undefined = null;
  @Input() parte: 'ambas' | 'principal' | 'secundaria' = 'ambas';
  /** Clase de la línea secundaria (la que antes llevaba el Bs). */
  @Input() subClass = 'kb-td-sub block';

  get tieneBs(): boolean { return this.bs !== null && this.bs !== undefined; }
}
